
type CardHeaderProps = {
    title: string;
    subtitle?: string;
}

const Header = ({ title, subtitle }: CardHeaderProps) => {
    return (
        <header className="flex flex-col gap-1">
            <h2 className='text-lg font-semibold'>{title}</h2>
            <p className='text-sm text-slate-500'>
                {subtitle}
            </p>
        </header>
    )
}

export default Header;